<!-- 【画面名】解答結果待ち画面 -->

<template>
  <CommonHeader />
  <div id="entry-question-wait" class="entry-question-wait">

    <div class="content">
      <div class="message-area">
        <p class="reception-message" v-if="receptionMessage" v-html='receptionMessage'></p>
        <p class="top-text" v-if="topText" v-html='topText'></p>

        <div id="errtext" class="errmsg" v-if="errorMessage" v-html='errorMessage'></div>

        <div class="fixed-link">
          <a class="fixed-link-text" v-if="fixedLinkText" v-html='fixedLinkText' v-on:click="clickNextLink"></a>
        </div>

        <p class="bottom-text">
          <span class="bottom-text-before" v-if="frontBottomText" v-html='frontBottomText'></span>
          <a class="fixed-link-text" v-if="fixedLinkText" v-html='fixedLinkText' v-on:click="clickNextLink"></a>
          <span class="bottom-text-after" v-if="rearBottomText" v-html='rearBottomText'></span>
        </p>

      </div>
    </div>
    <!-- /.content -->

  </div>

  <CommonFooter />
</template>

<script>
/* eslint-disable */
import CommonHeader from './CommonHeader.vue'
import CommonFooter from './CommonFooter.vue'

export default {
  name: 'EntryAnswerResultWait',
  components: {
    CommonHeader,
    CommonFooter,
  },
  data() {
    return {
      receptionMessage: '',
      topText: '',
      bottomText: '',
      fixedLinkText: '',
      frontBottomText: '',
      rearBottomText: '',
      linkName: '',
      linkUrl: '',
      frontLinkText: '',
      rearLinkText: '',
      errorMessage: '',
    }
  },
  inject: ['voteScreanInfo', 'getJson', 'getReservedWord'],
  mounted(){ // ページが読み込まれたらする処理
    // console.log(this.providedData[0].basic_info);
    
    var basicInfo = this.voteScreanInfo[0].basic_info;
    var reservedWord = this.voteScreanInfo[0].reserved_word;
    var questionInfo = this.voteScreanInfo[0].question_info;
    var displayInfo = this.voteScreanInfo[0].display_info;

    // テキスト設置
    this.topText = this.getReservedWord(displayInfo.ans_result_wait_information.arws_top_text);
    this.fixedLinkText = displayInfo.ans_result_wait_information.arws_fixed_link_text;
    this.frontBottomText = displayInfo.ans_result_wait_information.arws_front_bottom_text;
    this.rearBottomText = displayInfo.ans_result_wait_information.arws_rear_bottom_text;
    this.linkName = displayInfo.ans_result_wait_information.arws_rear_bottom_text;
  },
  methods: { // 使い回す関数

    clickNextLink() {
      this.getJson();
    }

  },
}
/* eslint-disable */
</script>

